import React from 'react'
import { FormikProps } from 'formik'
import { getSubscriberName, InsuranceFormValues } from '@modmd/data'
import { Dialog } from 'components/Dialog'
import { Box } from 'components/Layout'

import Card from 'components/Card'
import { FormInsurance } from 'client-portal/routes/RequestTestSession/FormInsurance'
import { Divider } from 'sharedComponents/Divider'
import Button from 'components/Button'
import { UserInfo } from 'components/UserInfo'
import { Text } from 'components/Typography'
import { format } from 'date-fns'

interface InsuranceInfoProps {
  insuranceForm?: FormikProps<InsuranceFormValues>
}
export const InsuranceInfo = ({ insuranceForm }: InsuranceInfoProps) => {
  const [isDialogOpen, setIsDialogOpen] = React.useState(false)

  const hasInsurance = React.useMemo(
    () =>
      insuranceForm?.values.insuranceCompany &&
      insuranceForm?.values.govId &&
      insuranceForm?.values.insuranceCardFront &&
      insuranceForm?.values.insuranceCardBack,
    [insuranceForm]
  )

  const subscriberName = getSubscriberName(
    insuranceForm?.values.subscriberFirstName,
    insuranceForm?.values.subscriberMiddleName,
    insuranceForm?.values.subscriberLastName
  )

  return (
    <>
      <Box mt="2rem">
        <Box display="flex" justifyContent="space-between">
          <Text>Insurance Info</Text>
          {hasInsurance && (
            <Button appearance="link" onClick={() => setIsDialogOpen(true)}>
              Edit
            </Button>
          )}
        </Box>
        <Divider />
        {hasInsurance ? (
          <Box>
            <UserInfo label="Insurance Company" text={insuranceForm?.values.insuranceCompany} />
            <UserInfo label="Plan" text={insuranceForm?.values.plan} />
            <UserInfo label="ID #" text={insuranceForm?.values.cardID} />
            <UserInfo label="Group #" text={insuranceForm?.values.groupNumber} />
            <UserInfo label="Subscriber" text={subscriberName} />
            <UserInfo label="SSN" text={insuranceForm?.values.SSN} />
            <UserInfo
              label="Government-Issued Id Card #"
              text={insuranceForm?.values.driversLicense}
            />
            <UserInfo
              label="Relationship To Subscriber"
              text={insuranceForm?.values.relationToSubscriber}
            />
            {insuranceForm?.values.relationToSubscriber !== 'self' && (
              <>
                <UserInfo
                  label="DOB"
                  text={
                    insuranceForm?.values.subscriberDOB &&
                    format(new Date(insuranceForm?.values.subscriberDOB), 'MM/dd/yyyy')
                  }
                />
                <UserInfo label="Gender" text={insuranceForm?.values.subscriberGender} />
              </>
            )}
          </Box>
        ) : (
          <Box display="flex" justifyContent="center">
            <Button onClick={() => setIsDialogOpen(true)}>Add Insurance Info</Button>
          </Box>
        )}
      </Box>
      <Dialog isOpen={!!isDialogOpen} onDismiss={() => setIsDialogOpen(false)} maxWidth="600px">
        <Box>
          <Card.Title onDismiss={() => setIsDialogOpen(false)}>Insurance</Card.Title>
          <Card.Content>
            <FormInsurance
              userId=""
              insuranceFormNewUser={insuranceForm}
              onClose={() => setIsDialogOpen(false)}
              insurances={insuranceForm?.values}
            />
          </Card.Content>
        </Box>
      </Dialog>
    </>
  )
}
